export class FilterDeserializerResult<T> {
    public static some<T>(value: T) {
        return new FilterDeserializerResult(value, true);
    }

    public static none() {
        return new FilterDeserializerResult(undefined, false);
    }

    private readonly _isSome: boolean;

    constructor(public readonly value: T, isSome: boolean) {
        this._isSome = isSome;
    }

    public isSome(): this is { value: FilterDeserializerResult<T> } {
        return this._isSome;
    }

    public isNone(): this is { value: FilterDeserializerResult<undefined> } {
        return !this.isSome();
    }
}
